import { defineStore } from "pinia";
import { ApiOrderBlPaper, ApiPublicDataGet } from "@/lib/api";

export const orderSecurePaper = defineStore("orderSecurePaper", {
  state: () => ({
    addressDetails: null,
    addressError: false,
    publicData: null,
    submitError: false,
    caseNumber: null,
    loading: true,
    tradingName: null
  }),
  actions: {
    async getAddressDetails() {
      try {
        const response = await ApiPublicDataGet();
        this.publicData = response?.[0];
        this.tradingName = response?.[0]?.tradingName;
        this.addressDetails =
          response?.[0]?.tradingName + "\n" + this.formattedAddress(response?.[0]?.customerAddressDetails);
      } catch (e) {
        this.addressError = true;
      } finally {
        this.loading = false;
      }
    },
    formattedAddress(customerAddressDetails) {
      if (customerAddressDetails) {
        const { buildingNo, houseNo, streetName, city, postalCode, country } = customerAddressDetails;
        return [
          `${buildingNo ? buildingNo + " " : ""}${houseNo ? houseNo + " " : ""}${streetName || ""}`,
          city,
          postalCode,
          country
        ]
          .filter(Boolean)
          .join(",\n");
      } else {
        return "";
      }
    },
    async requestOrderSecurePaper(reamsValue, comments) {
      try {
        const queryParams = {
          requesterOrgName: this.tradingName,
          reamCount: reamsValue,
          additionalInfo: comments,
          customerAddress: this.addressDetails
        };
        const response = await ApiOrderBlPaper(queryParams);
        this.caseNumber = response?.caseNumber;
      } catch (e) {
        this.submitError = true;
      }
    }
  }
});
